import { Trans, useTranslation } from 'react-i18next';

import { useAnyOrganizationDevicesFiltersActive } from '../../../../../../features/organization';
import { EmptyState } from '../../../../empty-state';
import { EmptyDevicesImage } from '../../../../images';
import { INoDevicesProps } from './types';

export const NoDevices = ({ expanded }: INoDevicesProps) => {
  const { t } = useTranslation();
  const anyFiltersActive = useAnyOrganizationDevicesFiltersActive();

  return (
    <EmptyState
      image={<EmptyDevicesImage />}
      title={t(`organization.devices.empty.title.${expanded || !anyFiltersActive ? 'noDevices' : 'noResult'}`)}
      subtitle={
        <Trans
          i18nKey={`organization.devices.empty.subtitle.${
            !expanded ? 'noDevices' : anyFiltersActive ? 'noResult' : 'noDevicesExtended'
          }`}
          components={[<span key="span" className="typography-inline-highlight-3" />]}
        />
      }
    />
  );
};
